<template>
    <div>
    <Header :title="title"/>
    <div class="content_balans">
        <table>
        <tr>
            <td><div class="textcomment"><span >В кошельке:</span></div></td>
            <td align="right"><div class="textbalans" ><span >{{ balans }} c.</span></div></td>
        </tr>
    </table>
    </div>
    
      <div class="content_podat">
        <div v-for="c in arr" :key="c.id" class="block_radio">
          <input
            class="custom-radio"
            name="color"
            v-model="kateg"
            type="radio"
            :id="c.id"
            :value="c.id"
            @change="select"
          />
          <label :for="c.id">
            <table>
              <tr>
                <td>
                  <div :class="c.id">
                    <img :src="c.img" :alt="c.text" />
                  </div>
                </td>
                <td width="100%"><span>{{ c.text }}</span></td>
              </tr>
            </table>
          </label>
        </div>
           <div v-if="dcbtn" class="stylebtndc">
            <button class="btnss" @click="fun_dc()">Пополнит через ДС</button>
           </div>
              
        

         <div class="content_info_oplata">
             <div><span>{{ text_step1 }}</span></div>
             <img :src="img_step1"/>
             <div><span>{{ text_step2 }}</span></div>
             <img :src="img_step2"/>
             <div><span>{{ text_step3 }}</span></div>
             <img :src="img_step3"/>
             <div><span>{{ text_step4 }}</span></div>
             <img :src="img_step4"/>
             <div><span>{{ text_step5 }}</span></div>
         </div>
        

      </div>
    </div>
  </template>
  
  <script>
  import Header from '../blocks/header3';
  
  export default {
    components: {
      Header
    },
  
    data() {
      return {
        title: "Пополнить кошелек",
        kateg: "",
        txtkateg: "",
        text_step1:"",
        text_step2:"",
        text_step3:"",
        text_step4:"",
        text_step5:"",
        img_step1:"",
        img_step2:"",
        img_step3:"",
        img_step4:"",
        tell:"",
        balans:0,
        dcbtn:false,
        arr: [
          {
            id: "dc",
            text: "Душанбе Сити",
            img: require('../assets/image/ic_dc.png')
          },
          {
            id: "eskhata",
            text: "Эсхата Онлайн",
            img: require('../assets/image/ic_eskhata.png')
          },
          {
            id: "alif",
            text: "Алиф моби",
            img: require('../assets/image/ic_alif.png')
          }
        ]
      };
    },
  
    methods: {
      fun_dc(){
        window.open("http://pay.dc.tj/?a=" + encodeURIComponent(this.tell) + "&s=0&c=Avtobaza.tj&f1=424&f2=&f3=", "_blank");
      },
      select() {
        const selectedOption = this.arr.find(item => item.id === this.kateg);
        if (selectedOption) {
          this.txtkateg = selectedOption.text;
          if(selectedOption.id == "eskhata"){
              this.dcbtn=false;
              this.text_step1="1. Откройте мобильное приложение «Эсхата онлайн» и нажмите кнопку «Платежи и переводы»";
              this.img_step1="https://avtobaza.tj/image/eskhata1.jpg";
              this.text_step2="2. Выберите «Онлайн-сервисы»";
              this.img_step2="https://avtobaza.tj/image/eskhata2.jpg";
              this.text_step3="3. Выберите «Avtobaza.tj»";
              this.img_step3="https://avtobaza.tj/image/eskhata3.jpg";
              this.text_step4="4. Введите свой номер телефона (" + this.tell + "), который вы ввели при регистрации.Укажите сумму, которую вы хатите заплатить. Нажмите «Продолжить»";
              this.img_step4="https://avtobaza.tj/image/eskhata4.jpg";
              this.text_step5="После пополнения средства будут зачислены на ваш кошелек на Avtobaza.tj";
          }
          if(selectedOption.id == "dc"){
            this.dcbtn=true;
              this.text_step1="1. Откройте мобильное приложение «Душанбе Сити» и нажмите кнопку «Оплата услуг»";
              this.img_step1="https://avtobaza.tj/image/dc1.jpg";
              this.text_step2="2. Выберите «Другое»";
              this.img_step2="https://avtobaza.tj/image/dc2.jpg";
              this.text_step3="3. Выберите «Avtobaza.tj»";
              this.img_step3="https://avtobaza.tj/image/dc3.jpg";
              this.text_step4="4. Введите свой номер телефона (" + this.tell + "), который вы ввели при регистрации.Укажите сумму, которую вы хатите заплатить. Нажмите «Далее»";
              this.img_step4="https://avtobaza.tj/image/dc4.jpg";
              this.text_step5="После пополнения средства будут зачислены на ваш кошелек на Avtobaza.tj";
          }
          if(selectedOption.id == "alif"){
            this.dcbtn=false;
              this.text_step1="1. Откройте мобильное приложение «Алиф моби» и нажмите кнопку «Оплатить»";
              this.img_step1="https://avtobaza.tj/image/alif1.jpg";
              this.text_step2="2. Выберите «Объявления»";
              this.img_step2="https://avtobaza.tj/image/alif2.jpg";
              this.text_step3="3. Выберите «Avtobaza.tj»";
              this.img_step3="https://avtobaza.tj/image/alif3.jpg";
              this.text_step4="4. Введите свой номер телефона (" + this.tell + "), который вы ввели при регистрации.Укажите сумму, которую вы хатите заплатить. Нажмите «Далее»";
              this.img_step4="https://avtobaza.tj/image/alif4.jpg";
              this.text_step5="После пополнения средства будут зачислены на ваш кошелек на Avtobaza.tj";
          }
        }
      }
    },
  
    computed: {
        getpostuser() {
        return this.$store.getters.getpostuser;
        },
    },
    created() {
        if (!localStorage.getItem("token")) {
            this.$router.go(-1);
        }
    },
  
    mounted() {
        if (this.getpostuser.name) {
        this.tell=this.getpostuser.tel;
        this.balans=this.getpostuser.balans;
      }
    }
  };
  </script>
  
  <style scoped>
  .content_info_oplata img{
    width:100%;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
  }
  .content_info_oplata span{
    font-size: 18px;
  }
  .block_radio {
    margin-bottom: 0.5em;
  }
  .divgorod {
    width: 100%;
    color: #777777;
  }
  .contentgorod {
    font-size: 20px;
    border-bottom: 1px solid #000000;
    padding: 5px 5px 5px 0px;
  }
  label {
    font-size: 18px;
    width: 100%;
  }
  .content_podat {
    padding: 10px 5px 65px 10px;
  }
  .textcomment{
    color: #666;
    font-size: 18px;
  }
  .textbalans{
    color: #000;
    font-size: 18px;
  }
  .content_balans{
    padding-top: 70px;
    margin: 10px;
  }
  .stylebtndc{
    margin-top: 20px;
    margin-bottom: 40px;
  }
  </style>